export const SubscriptionStatusCssClasses = ["success", "info", ""];
export const SubscriptionStatusTitles = ["active", "inactive"];
export const SubscriptionConditionCssClasses = ["success", "danger", ""];
export const SubscriptionConditionTitles = ["New", "Used"];
export const defaultSorted = [{ dataField: "id", order: "asc" }];
export const sizePerPageList = [
  { text: "30", value: 30 },
  { text: "50", value: 50 },
  { text: "100", value: 100 }
];
export const initialFilter = {
  filter: {
    name: "",
    type:-1
  },
  sortOrder: "asc", // asc||desc
  sortField: "id",
  pageNumber: 1,
  pageSize: 50
};
